import ring from '../elements/ring.js';
ring.register();
